import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ROUTES } from 'src/navigation';
import { Heading } from '@innovationnorway/cl-react';

const Update = () => {
  const { t: tHelpAndSupport } = useTranslation('onboarding');

  return (
    <div className="stack">
      <Heading level={2}>{tHelpAndSupport('commonQuestions.GoalAchievement.Update')}</Heading>
      <p>{tHelpAndSupport('commonQuestions.GoalAchievement.Update.Text1')}</p>
      <p>{tHelpAndSupport('commonQuestions.GoalAchievement.Update.Text2')}</p>
      <Link className="display--block" to={ROUTES.SIVA.REPORTING.ACHIEVED.BASE}>
        {tHelpAndSupport('commonQuestions.SivaReporting.GoalAchievement.Link')}
      </Link>
    </div>
  );
};

export default Update;
